export var MuiCheckbox = {
  styleOverrides: {
    root: {
      alignSelf: 'start',
      '& + span.MuiTypography-root': {
        paddingTop: '5px'
      }
    }
  }
};
//# sourceMappingURL=MuiCheckbox.js.map